import { Link } from 'react-router-dom';
import heroDesktop from '../assets/brand/hero.webp';
import heroMobile from '../assets/brand/hero-mobile.webp';
import logo from '../assets/brand/umrx-logo.webp';
import { siteLinks } from '../data.js';
import { ArrowUpRightIcon } from '../components/Icons.jsx';

export function HomePage() {
  return (
    <>
      <section className="hero">
        <picture className="hero-image">
          <source media="(max-width: 680px)" srcSet={heroMobile} />
          <img src={heroDesktop} alt="The Uncle Mike Ruins Christmas cast in full festive chaos" />
        </picture>
        <div className="hero-wash" />
        <div className="hero-content page-width">
          <p className="eyebrow light">Seattle’s Most Beloved & Distasteful Holiday Comedy Show</p>
          <img className="hero-logo" src={logo} alt="Uncle Mike Ruins Christmas" />
          <h1>Sorry. No Uncle Mike in 2026<br /></h1>
          <p className="hero-copy">
            Check back for the 20th year in 2027
          </p>
          <div className="hero-actions">
            <a className="button button-light" href={siteLinks.ticketUrl} target="_blank" rel="noreferrer">
              Get tickets <ArrowUpRightIcon />
            </a>
            <Link className="text-link light" to="/about">See how it works <span>→</span></Link>
          </div>
        </div>
        <div className="hero-note">Mature content. Immature people.</div>
      </section>

      <section className="intro page-width section-pad">
        <div className="section-number">01</div>
        <div>
          <p className="eyebrow">Bring us your cherished holiday memory</p>
          <h2 className="display-heading">You tell us what happened. We ruins it.</h2>
        </div>
        <div className="intro-copy">
          <p>
            Write down a heartwarming holiday memory. We re-enact it. Then Uncle Mike ruins it in ways no sane human should be able to imagine.
          </p>
          <Link className="text-link" to="/about">Meet the show <span>→</span></Link>
        </div>
      </section>

      <section className="quote-strip">
        <div className="page-width quote-grid">
          <blockquote>
            “Bawdy retellings of audience members’ anecdotes… for those whose hearts are two sizes too small.”
            <cite>Seattle Met</cite>
          </blockquote>
          <blockquote>
            “A foul, perverted, and often funny satire of family dysfunction.”
            <cite>Seattle Weekly</cite>
          </blockquote>
        </div>
      </section>

      <section className="home-cta page-width section-pad">
        <p className="eyebrow">The whole dysfunctional family</p>
        <div className="home-cta-row">
          <h2 className="display-heading">Meet the cast</h2>
          <Link className="round-link" to="/cast" aria-label="Meet the cast">→</Link>
        </div>
      </section>
    </>
  );
}
